import ITask from './ITask';
import { OverlayFadeIn, OverlayFadeOut, Scale } from 'System/Animation/Clip';
import { AwaitIterators, ConcatIterators, PlayAnimation } from 'System/Animation/AnimationHelper';
import { delay } from './TaskQueue';
import WorldSystem from 'System/World/WorldSystem';
import GameObject from 'GameObject/GameObject';
import WorldHUDHandler from 'System/UI/HUD/WorldHUDHandler';
import { RenderSystemEvent } from 'System/Render/RenderSystem';
import OverlayComponent from 'Component/UI/Overlay';
import Game from 'Game';
import Point from '../Point';
import Text from 'Prototype/Text';
import { Easing } from '@tweenjs/tween.js';
import { PlayerActions } from 'State/Player/PlayerActions';
import { FTUXType } from 'Player/PlayerProperty/Progress/FTUXType';
import { PopupID } from 'State/UI/PopupID';
import { UIActions } from 'State/UI/UIActions';

export default class XmasFTUXTask implements ITask<WorldSystem> {
    public *execute(system: WorldSystem): IterableIterator<any> {
        UIActions.showPopup(PopupID.EVENT_INTRO, {});

        yield* this.yieldUntilPopupClosed(PopupID.EVENT_INTRO);

        system.scene.emit(RenderSystemEvent.BRING_TO_FRONT, system.animator);
        const overlay = system.animator.getChildByName('overlay');
        const questButton = GameObject.findFirstByName(WorldHUDHandler.QUESTS_BTN_NAME);
        const questButtonParent = questButton.parent;

        const text = GameObject.Instantiate(Text, {
            relativePosition: new Point(0.5, 0.77),
            text: Game.locale.getText('XmasFTUXQuest'),
            style: Game.style.getStyle('quests.FTUX'),
            anchor: Point.Center,
            scale: Point.Zero,
        });
        system.animator.addChild(text);
        system.animator.addChild(questButton);

        overlay.getComponent(OverlayComponent).preventInteraction = true;

        yield* ConcatIterators([
            PlayAnimation(new OverlayFadeIn(overlay)),
            PlayAnimation(
                new Scale(text, {
                    startScale: Point.Zero,
                    endScale: Point.One,
                    duration: 250,
                    easing: Easing.Back.Out,
                })
            ),
            this.yieldUntilPopupOpened(PopupID.QUEST_MENU),
            AwaitIterators([
                PlayAnimation(new OverlayFadeOut(overlay)),
                PlayAnimation(
                    new Scale(text, {
                        startScale: Point.One,
                        endScale: Point.Zero,
                        duration: 250,
                        easing: Easing.Back.In,
                    })
                ),
            ]),
            this.yieldUntilPopupClosed(PopupID.QUEST_MENU),
        ]);
        questButtonParent.addChild(questButton);
        overlay.getComponent(OverlayComponent).preventInteraction = false;
        PlayerActions.setFTUXUnlocks([FTUXType.XMAS]);
    }

    private *yieldUntilPopupClosed(popupID: PopupID) {
        let state = Game.store.getState();
        while (state.UIState.popupID === popupID) {
            yield* delay(100);
            state = Game.store.getState();
        }
    }

    private *yieldUntilPopupOpened(popupID: PopupID) {
        let state = Game.store.getState();
        while (state.UIState.popupID !== popupID) {
            yield* delay(100);
            state = Game.store.getState();
        }
    }
}
